<template>
  <div>
    <!-- Search -->
    <div ref="index" class="row mb-2">
      <div class="col-md-6">
        <input v-model="query.generic" class="input form-control" @keypress.enter="find"
          placeholder="Pesquisar por Nome">
        <search-icon @click="find" class="icon icon-within" />
      </div>

      <div v-if="$withPolicy('application', 'customField/insert_or_update')" class="col-md-6">
        <button @click="openModal" class="btn btn-primary btn-lg">
          Cadastrar campo
        </button>
      </div>
    </div>

    <!-- Table  -->
    <div class="row">
      <div class="col-md-12">
        <table class="table table-borderless table-border table-align table-h51">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Recurso</th>
              <th>Tipo</th>
              <th>Descrição</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="customField in customFields" :key="customField.id">
              <td>{{ customField.name }}</td>
              <td :title="resourceDescription(customField.resource)">{{ customField.resource | resource }}</td>
              <td>{{ customField.kind === 'input' ? 'Valor' : 'Seleção' }}</td>
              <td :title="customField.description" class="truncate-1">{{ customField.description }}</td>
              <td class="text-right">
                <button class="btn btn-sm btn-outline" @click="setEdit(customField)">
                  <edit-icon size="1.5x" />
                </button>
                <button class="btn btn-sm btn-outline-red ml-1" @click="deleteLabel(customField)">
                  <trash-2-icon size="1.5x" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination -->
    <div class="row">
      <div class="col-md-12 my-1">
        <Pagination v-model="meta.currentPage" :total-count="meta.totalCount" :total-pages="meta.totalPages"
          @pagination="pagination" />
      </div>
    </div>

    <FormModal v-model="showModal" :customField="currentCustomField" @savedCustomField="find" />
  </div>

</template>

<script>
import FormModal from '@/components/custom_fields/Modal'
import Pagination from '@/components/shares/specialTag/Pagination'
import ModelMapper from '@/mixins/ModelMapper'
import EntityProxy from '@/models/EntityProxy'

import { SearchIcon, Trash2Icon, EditIcon } from 'vue-feather-icons'

const mapResources = {
  'Company': ['Empresa', 'Recurso disponivel apenas para empresas'],
  'Vehicle': ['Veículo', 'Recurso disponivel apenas para veículos'],
  'cm-embarcador/multa': ['Multa embarcador', 'Recurso disponivel apenas para multas de embarcador'],
  'cm-frotas/ticket': ['Multa frotas', 'Recurso disponivel apenas para multas de frotas'],
}

export default {
  components: { FormModal, Pagination, SearchIcon, Trash2Icon, EditIcon },
  computed: {
    customFields() {
      return this.getModels ? EntityProxy.build(this.getModels) : []
    },
    currentAxios() {
      return this.axios.v3
    },
  },
  created() {
    this.find()
  },
  data: () => ({
    currentCustomField: {},
    loadCustomFields: true,
    managerLabels: false,
    nameModel: 'CustomField',
    showModal: false,
  }),
  methods: {
    openModal() {
      this.currentCustomField = EntityProxy.build({})
      this.showModal = true
    },
    closeModal() {
      this.$emit('input', false)
      this.managerLabels = false
    },
    deleteLabel(customField) {
      if (!confirm('Tem certeza?\nTodos os itens associado a este marcador serão desmarcados.'))
        return

      this.asyncTemplateDelete(customField, {
        after: () => {
          this.$notify.add('CustomField excluído com sucesso!')
          this.find()
          this.$emit('deleteLabel', customField)
        }
      })
    },
    find() {
      this.asyncTemplateSelect({
        after: () => this.loadCustomFields = false,
      })
    },
    setEdit(customField) {
      this.currentCustomField = customField.clone()
      this.showModal = true
    },
    resourceDescription(resource) {
      const result = mapResources[resource]
      return result ? result[1] : ''
    },
  },
  filters: {
    resource(resource) {
      const result = mapResources[resource]
      return result ? result[0] : resource
    },
  },
  mixins: [ModelMapper],
  name: 'CustomFieldIndex',
}
</script>

<style scoped></style>
